import { useEffect, useState } from 'react';
import { formatDate } from '../../components/Util/format_date';

import { get_day_epg } from '../../server/requests'

import './ProgramGuide.scss'

import play_icon from '../../components/Pages/Player/images/play.png'
import { useRouter } from '../../hooks/router';

import def_image_epg from './images/epg_default_image.png'

export default ({
    listChannels,
    activeChannelId,
    allChannels,
    setEpg,
    select_day_epg_live,
    callBackArchive
}) => {

    const router = useRouter()

    const [days, setDays] = useState([])
    const [activeDay, setActiveDay] = useState(0)
    const [epgList, setEpgList] = useState([])
    const [activeEpgIndex, setActiveEpgIndex] = useState('')

    useEffect(() => {

        let _arr = []

        for (let i = -5; i <= 5; i++) {
            let _date = new Date()
            _date = _date.setDate(_date.getDate() + i)

            let obj = {
                date: _date,
                id: i,
                selected: false,
            }

            if (i == 0) {
                obj.selected = true
                obj.current = true
                setActiveDay(0)
            }

            _arr.push(obj)

        }

        setDays([..._arr])
    }, []);

    useEffect(() => {
        // 
        if (allChannels.length && router.query.id) {
            let active_channel = allChannels.find(e => e.id == router.query.id)

            if (active_channel) {
                const body = {
                    date: activeDay,
                    id: active_channel.id_epg
                }
                //     get_day_epg(activeDay)
                req_get_day_epg(body)
            }

        }
    }, [allChannels.length, activeDay, router.query.id])

    const req_get_day_epg = (body) => {


        // if (active_channel) {

        get_day_epg(body, data => {
            if (data.length) {
                setEpgList([...data])
                sort_epg_in_stream(data)
            } else {
                setEpgList([])
            }
        })
        // }

    }

    function sort_epg_in_stream(data) {

        var now = new Date().getTime() / 1000;

        for (var i = 0; i < data.length; i++) {

            if (data[i].start_ut < now && now < data[i].stop_ut) {

                setActiveEpgIndex(i)

                setEpg({
                    Now: data[i] ? data[i] : null,
                    next: data[i + 1] ? data[i + 1] : null
                })
                break

            }

        }

    }

    const _set_play_btn = (e, i) => {
        setEpg(e)
        setActiveEpgIndex(i)
    }

    const _btn_play_archive = (el) => {
        callBackArchive(el)
    }

    const error_load_image = (e) => {
        e.target.src = def_image_epg
    }

    const image_flussonic = (el, active_channel) => {

        var date = new Date(el.start_ut * 1000);

        var year = date.getFullYear().toString()
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var day = date.getDate().toString().padStart(2, "0");
        var hour = date.getHours().toString().padStart(2, "0");
        var minute = date.getMinutes().toString().padStart(2, "0");
        var seconds = date.getSeconds().toString().padStart(2, "0");

        var url = `${active_channel?.archived_channel?.url}/${year}/${month}/${day}/${hour}/${minute}/${seconds}.jpg`

        return (
            <img
                src={url}
                onError={error_load_image}
                className='image_live_card'
                alt=""
            />
        )

    }

    return (
        <>
            <div className="days_program_guide_live">
                {
                    days.map((e, i) => {
                        return (
                            <div key={e.id} data_index={e.id} onClick={() => setActiveDay(e.id)} className={"card_color card_days_live " + (e.id == activeDay ? "selected " : '') + (e.current ? 'today' : '')}>
                                <h4>{formatDate(new Date(e.date), 'dd')}</h4>
                                <p>{formatDate(new Date(e.date), 'EEEE').toUpperCase()}</p>
                                <div className="shadow_days_epg"></div>
                            </div>
                        )
                    })
                }
            </div>

            <div className="main_epg_live">
                {epgList.map((el, index) => {
                    //get  utc time
                    let date = new Date();

                    // Get UTC time components
                    let utcYear = date.getUTCFullYear();
                    let utcMonth = date.getUTCMonth() + 1; // Months are zero-indexed, so add 1
                    let utcDay = date.getUTCDate();
                    let utcHours = date.getUTCHours();
                    let utcMinutes = date.getUTCMinutes();
                    let utcSeconds = date.getUTCSeconds();

                    // Format the UTC time as a string
                    var utcTime = utcYear + "-" + utcMonth + "-" + utcDay + " " + utcHours + ":" + utcMinutes + ":" + utcSeconds;

                    let time = new Date(utcTime).getTime() / 1000

                    let active_channel = allChannels.find(e => e.id == router.query.id)

                    return (
                        <div
                            key={index}
                            className="epg_card_live card_color"
                            id={time > el.start_ut && time < el.stop_ut ? 'refElem' : ''}
                            onClick={() => _set_play_btn(el, index)}
                        >
                            {
                                active_channel?.archived_channel?.type == "flussonic" ?
                                    image_flussonic(el, active_channel)
                                    :
                                    <img className='image_live_card' onError={error_load_image} src={`http://${active_channel?.archived_channel?.archiver?.ip}:${active_channel?.archived_channel?.archiver?.port}/archive/screenshots/${active_channel?.archived_channel?.id}/${el.start_ut * 1000}/epg.jpg`} alt="" />

                            }
                            <div className="parent_time_epg_card">
                                <p className="time_epg_card">{formatDate(new Date(el.start_ut * 1000), 'HH:mm')}-{formatDate(new Date(el.stop_ut * 1000), 'HH:mm')}</p>
                            </div>
                            <div className={"active_epg_circle " + (time > el.start_ut && time < el.stop_ut ? 'green' :
                                time < el.start_ut ? 'grey' : "red")}

                            ></div>
                            <p className="title_epg_card">{el.title}</p>
                            {time > el.start_ut ?
                                <div className={'play_archive_program_guide'}
                                    onClick={() => _btn_play_archive(el)}>

                                </div>
                                : null}
                        </div>
                    )
                })}
            </div>
        </>
    )

}